export const REPORTS_LOADED = "reports/reportsLoaded"
export const REPORTS_ADDED = "reports/reportsAdded"
export const REPORT_ADDED = "reports/reportAdded"
export const REPORT_UPDATED = "reports/reportUpdated"
export const REPORT_DELETED = "reports/reportDeleted"
export const REPORTS_DELETED = "reports/reportsDeleted"